import { render, staticRenderFns } from "./product.vue?vue&type=template&id=4fd463b2&scoped=true&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&id=4fd463b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd463b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fd463b2')) {
      api.createRecord('4fd463b2', component.options)
    } else {
      api.reload('4fd463b2', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=4fd463b2&scoped=true&", function () {
      api.rerender('4fd463b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/print/components/product.vue"
export default component.exports